import { render, staticRenderFns } from "./SeriesHistoryEdit.vue?vue&type=template&id=57286bbc&scoped=true&"
import script from "./SeriesHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./SeriesHistoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57286bbc",
  null
  
)

export default component.exports